// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBoundaryFallback_wrapper__SWu16","grow":"ErrorBoundaryFallback_grow__ANGWN"};